define("settings/components/cluster/social-profile-tabs", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "moment", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _computed, _service, _utils, _component2, _tracking, _emberConcurrency, _moment, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"moment",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.showingAnyTabs}}
    <nav class="o--nav--underline" {{did-insert this.setInitialActiveTab}}>
      {{#if this.showIndustryTab}}
        <div class="o--nav__item">
          <Shared::Ui::Button
            @class={{if this.showingIndustry "active"}}
            @onClick={{set this "activeTab" "industry"}}
            @text={{t "account.social_accounts.industry.label"}}
            @variant="unstyled"
            class="o--nav__link"
          />
        </div>
      {{/if}}
      {{#if this.showDeviceTab}}
        <div class="o--nav__item">
          <Shared::Ui::Button
            @class={{if this.showingDevices "active"}}
            @onClick={{set this "activeTab" "devices"}}
            @text={{t "shared_phrases.devices_to_notify"}}
            @variant="unstyled"
            class="o--nav__link"
          />
        </div>
      {{/if}}
      {{#if this.showAutoPublishTab}}
        <div class="o--nav__item" data-test-id="auto-publish-tab">
          <Shared::Ui::Button
            @class={{if this.showingAutoPublishTab "active"}}
            @onClick={{set this "activeTab" "autoPublish"}}
            @text={{t "account.social_accounts.auto_publish.label"}}
            @variant="unstyled"
            class="o--nav__link"
          />
        </div>
      {{/if}}
      {{#if this.showUsernameTab}}
        <div class="o--nav__item">
          <Shared::Ui::Button
            @class={{if this.showingUsername "active"}}
            @onClick={{set this "activeTab" "username"}}
            @text={{t "account.social_accounts.username.header"}}
            @variant="unstyled"
            class="o--nav__link"
          />
        </div>
      {{/if}}
    </nav>
    <div class="u--m__t__md">
      {{#if this.showingIndustry}}
        <Profiles::Industry
          @businessModel={{this.businessModel}}
          @canChangeIndustry={{this.canChangeIndustry}}
          @goToPartnerships={{this.goToPartnerships}}
          @industry={{this.industry}}
          @industryChangeFrequencyInDays={{this.industryChangeFrequencyInDays}}
          @industryNextChangeTime={{this.industryNextChangeTime}}
          @promptToEditIndustry={{this.promptToEditIndustry}}
          @showPartnershipsOptIn={{this.showPartnershipsOptIn}}
        />
      {{/if}}
      {{#if this.showingDevices}}
        <Profiles::DeviceNotify
          @addRemoveDevice={{@addRemoveDevice}}
          @devices={{@devices}}
          @socialProfile={{@socialProfile}}
        />
      {{/if}}
      {{#if this.showingAutoPublishTab}}
        <Profiles::AutoPublish @saveSocialProfile={{@saveSocialProfile}} @socialProfile={{@socialProfile}} />
      {{/if}}
      {{#if this.showingUsername}}
        <Profiles::UserName @updateProfileNickname={{this.updateProfileNickname}} @username={{this.username}} />
      {{/if}}
    </div>
  {{/if}}
  
  {{#if this.showProfileCategorizationModal}}
    <Shared::ProfileCategorization::Modal
      @forceHideReports={{true}}
      @isProfileCategorized={{and @socialProfile.industry @socialProfile.businessModel}}
      @isRecategorizingFromChangeIndustryTab={{true}}
      @sectionName="analytics"
      @socialProfile={{@socialProfile}}
      @toggleCategorizationModal={{toggle-action "showProfileCategorizationModal" this}}
    />
  {{/if}}
  */
  {
    "id": "bCm1zEX1",
    "block": "[[[41,[30,0,[\"showingAnyTabs\"]],[[[1,\"  \"],[11,\"nav\"],[24,0,\"o--nav--underline\"],[4,[38,1],[[30,0,[\"setInitialActiveTab\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showIndustryTab\"]],[[[1,\"      \"],[10,0],[14,0,\"o--nav__item\"],[12],[1,\"\\n        \"],[8,[39,2],[[24,0,\"o--nav__link\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[52,[30,0,[\"showingIndustry\"]],\"active\"],[28,[37,3],[[30,0],\"activeTab\",\"industry\"],null],[28,[37,4],[\"account.social_accounts.industry.label\"],null],\"unstyled\"]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showDeviceTab\"]],[[[1,\"      \"],[10,0],[14,0,\"o--nav__item\"],[12],[1,\"\\n        \"],[8,[39,2],[[24,0,\"o--nav__link\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[52,[30,0,[\"showingDevices\"]],\"active\"],[28,[37,3],[[30,0],\"activeTab\",\"devices\"],null],[28,[37,4],[\"shared_phrases.devices_to_notify\"],null],\"unstyled\"]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showAutoPublishTab\"]],[[[1,\"      \"],[10,0],[14,0,\"o--nav__item\"],[14,\"data-test-id\",\"auto-publish-tab\"],[12],[1,\"\\n        \"],[8,[39,2],[[24,0,\"o--nav__link\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[52,[30,0,[\"showingAutoPublishTab\"]],\"active\"],[28,[37,3],[[30,0],\"activeTab\",\"autoPublish\"],null],[28,[37,4],[\"account.social_accounts.auto_publish.label\"],null],\"unstyled\"]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showUsernameTab\"]],[[[1,\"      \"],[10,0],[14,0,\"o--nav__item\"],[12],[1,\"\\n        \"],[8,[39,2],[[24,0,\"o--nav__link\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[52,[30,0,[\"showingUsername\"]],\"active\"],[28,[37,3],[[30,0],\"activeTab\",\"username\"],null],[28,[37,4],[\"account.social_accounts.username.header\"],null],\"unstyled\"]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--m__t__md\"],[12],[1,\"\\n\"],[41,[30,0,[\"showingIndustry\"]],[[[1,\"      \"],[8,[39,5],null,[[\"@businessModel\",\"@canChangeIndustry\",\"@goToPartnerships\",\"@industry\",\"@industryChangeFrequencyInDays\",\"@industryNextChangeTime\",\"@promptToEditIndustry\",\"@showPartnershipsOptIn\"],[[30,0,[\"businessModel\"]],[30,0,[\"canChangeIndustry\"]],[30,0,[\"goToPartnerships\"]],[30,0,[\"industry\"]],[30,0,[\"industryChangeFrequencyInDays\"]],[30,0,[\"industryNextChangeTime\"]],[30,0,[\"promptToEditIndustry\"]],[30,0,[\"showPartnershipsOptIn\"]]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showingDevices\"]],[[[1,\"      \"],[8,[39,6],null,[[\"@addRemoveDevice\",\"@devices\",\"@socialProfile\"],[[30,1],[30,2],[30,3]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showingAutoPublishTab\"]],[[[1,\"      \"],[8,[39,7],null,[[\"@saveSocialProfile\",\"@socialProfile\"],[[30,4],[30,3]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showingUsername\"]],[[[1,\"      \"],[8,[39,8],null,[[\"@updateProfileNickname\",\"@username\"],[[30,0,[\"updateProfileNickname\"]],[30,0,[\"username\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showProfileCategorizationModal\"]],[[[1,\"  \"],[8,[39,9],null,[[\"@forceHideReports\",\"@isProfileCategorized\",\"@isRecategorizingFromChangeIndustryTab\",\"@sectionName\",\"@socialProfile\",\"@toggleCategorizationModal\"],[true,[28,[37,10],[[30,3,[\"industry\"]],[30,3,[\"businessModel\"]]],null],true,\"analytics\",[30,3],[28,[37,11],[\"showProfileCategorizationModal\",[30,0]],null]]],null],[1,\"\\n\"]],[]],null]],[\"@addRemoveDevice\",\"@devices\",\"@socialProfile\",\"@saveSocialProfile\"],false,[\"if\",\"did-insert\",\"shared/ui/button\",\"set\",\"t\",\"profiles/industry\",\"profiles/device-notify\",\"profiles/auto-publish\",\"profiles/user-name\",\"shared/profile-categorization/modal\",\"and\",\"toggle-action\"]]",
    "moduleName": "settings/components/cluster/social-profile-tabs.hbs",
    "isStrictMode": false
  });
  let SocialProfileTabsComponent = _exports.default = (_dec = (0, _computed.or)('args.socialProfile.isInstagram', 'args.socialProfile.isTiktok'), _dec2 = (0, _computed.reads)('args.socialProfile.isInstagram'), _dec3 = (0, _computed.reads)('args.socialProfile.nickname'), _dec4 = (0, _computed.reads)('args.socialProfile.industryLastChangedTime'), _dec5 = (0, _computed.reads)('args.socialProfile.industry'), (_class = class SocialProfileTabsComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "router", _descriptor3, this);
      _initializerDefineProperty(this, "activeTab", _descriptor4, this);
      _initializerDefineProperty(this, "showProfileCategorizationModal", _descriptor5, this);
      _defineProperty(this, "industryChangeFrequencyInDays", 30);
      _initializerDefineProperty(this, "showDeviceTab", _descriptor6, this);
      _initializerDefineProperty(this, "showIndustryTab", _descriptor7, this);
      _initializerDefineProperty(this, "username", _descriptor8, this);
      _initializerDefineProperty(this, "industryLastChangedTime", _descriptor9, this);
      _initializerDefineProperty(this, "lastSavedIndustry", _descriptor10, this);
      _defineProperty(this, "updateProfileNickname", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.socialProfile.nickname = this.username;
          return yield this.args.saveSocialProfile.perform();
        }
      }), null, "updateProfileNickname", "drop"));
    }
    get socialProfile() {
      return this.args.socialProfile;
    }
    get showingAutoPublishTab() {
      return this.activeTab === 'autoPublish';
    }
    get showingUsername() {
      return this.activeTab === 'username';
    }
    get showingDevices() {
      return this.activeTab === 'devices';
    }
    get showingIndustry() {
      return this.activeTab === 'industry';
    }
    get showAutoPublishTab() {
      if (this.socialProfile.isInstagram) {
        return this.socialProfile.hasProfessionalAccount;
      }
      if (this.socialProfile.isTiktok) {
        return this.socialProfile.canTiktokAutoPublish;
      }
      return false;
    }
    get showingAnyTabs() {
      return this.showDeviceTab || this.showAutoPublishTab || this.showIndustryTab;
    }
    get industry() {
      return this.socialProfile.industry ? this.intl.t(`profile_categorization.industries.${this.socialProfile.industry}`) : this.intl.t('account.social_accounts.industry.header_empty');
    }
    get businessModel() {
      return this.socialProfile.businessModel ? this.intl.t(`profile_categorization.business_models.${this.socialProfile.businessModel}`) : this.intl.t('account.social_accounts.industry.header_empty');
    }
    get showPartnershipsOptIn() {
      const hasOptedIn = this.socialProfile.socialIdentity.get('influencer')?.get('optedInAt');
      return this.socialProfile.businessModel === 'blog_influencer' && hasOptedIn !== undefined && !hasOptedIn;
    }
    get canChangeIndustry() {
      if (this.lastSavedIndustry && this.industryLastChangedTime) {
        const industryLastChangedTime = _moment.default.unix(this.industryLastChangedTime);
        const currentTime = (0, _moment.default)();
        return currentTime.diff(industryLastChangedTime, 'days') >= this.industryChangeFrequencyInDays;
      }
      return true;
    }
    get industryNextChangeTime() {
      const industryLastChangedTime = _moment.default.unix(this.industryLastChangedTime);
      return industryLastChangedTime.add(this.industryChangeFrequencyInDays, 'days').format('MMM D, YYYY');
    }
    get showUsernameTab() {
      return this.socialProfile.isTiktokUnverifiedAccount || this.socialProfile.isTiktokLoginKitAccount;
    }
    goToPartnerships() {
      const groupSlug = this.socialProfile.group.get('slug');
      this.router.transitionTo('cluster.partnerships.profile', groupSlug, this.socialProfile.socialIdentity.get('id'));
    }
    setInitialActiveTab() {
      if ((0, _utils.isNone)(this.args.activeTab) && this.showingAnyTabs) {
        if (this.showIndustryTab) {
          this.activeTab = 'industry';
        } else if (this.showDeviceTab) {
          this.activeTab = 'devices';
        } else if (this.showAutoPublishTab) {
          this.activeTab = 'autoPublish';
        } else if (this.showUsernameTab) {
          this.activeTab = 'username';
        }
      } else {
        this.activeTab = this.args.activeTab;
      }
    }
    async promptToEditIndustry(event) {
      event.preventDefault();
      this.dialogManager.confirm(this.intl.t('account.social_accounts.industry.confirm_modal.title'), {
        description: this.intl.t('account.social_accounts.industry.confirm_modal.body', {
          industryChangeFrequencyInDays: this.industryChangeFrequencyInDays
        }),
        confirmButton: this.intl.t('account.social_accounts.industry.confirm_modal.available.confirm')
      }).then(() => {
        this._toggleShowProfileCategorizationModal();
      });
    }
    _toggleShowProfileCategorizationModal() {
      this.showProfileCategorizationModal = !this.showProfileCategorizationModal;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "activeTab", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showProfileCategorizationModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showDeviceTab", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showIndustryTab", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "username", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "industryLastChangedTime", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "lastSavedIndustry", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "goToPartnerships", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPartnerships"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setInitialActiveTab", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setInitialActiveTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "promptToEditIndustry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "promptToEditIndustry"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialProfileTabsComponent);
});